import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OccEndpointsService, TranslationService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { tap, take } from 'rxjs/operators';
import { UigExportComponent } from 'src/app/components/uig-export/uig-export.component';
import { InvoiceHistoryRequestData } from './custom-user-payments.models';

@Injectable({
  providedIn: 'root',
})
export class CustomUserPaymentsService {
  constructor(
    private modalService: NgbModal,
    private httpClient: HttpClient,
    private endpoints: OccEndpointsService,
    private translation: TranslationService,
    private messageService: GlobalMessageService
  ) {}

  public printOrExportInvoiceHistory(formData: InvoiceHistoryRequestData): void {
    this.modalService.open(UigExportComponent, { centered: true }).result.then(
      (result) => {
        if (result === 'print') {
          window.print();
        } else {
          this.exportInvoiceHistory(result, formData);
        }
      },
      () => {}
    );
  }

  exportInvoiceHistory(
    selectExport: string,
    formData: InvoiceHistoryRequestData
  ) {
    const params = {
        dateFrom: formData.dateFrom,
        dateTo: formData.dateTo,
        invoiceNumber: formData.invoiceNumber,
        articleNumber: formData.articleNumber,
        adviceNumber: formData.adviceNumber,
        onlyOpen: formData.onlyOpen,
        referenceNumber: formData.referenceNumber,
        amountFrom: formData.amountFrom,
        amountTo: formData.amountTo,
        orderType: formData.orderType,
        bookingType: formData.bookingType
      };
    this.translation
      .translate('customUserPayments.downloadInfo')
      .pipe(take(1))
      .subscribe((message) => {
        this.messageService.add(message, GlobalMessageType.MSG_TYPE_INFO);
      });
    const url = this.endpoints.buildUrl('customUserPaymentsDownload', {queryParams: params});
    var fileNameLoc = 'customUserPayments.files.overview'
    this.httpClient
      .post(url, null, { observe: 'body', responseType: 'blob' })
      .pipe(
        tap(
          (data) => {
            this.translation
              .translate(fileNameLoc)
              .pipe(take(1))
              .subscribe((fileName) => {
                var a = document.createElement('a');
                a.setAttribute('download', fileName + '.' + selectExport);
                a.href = URL.createObjectURL(data);
                a.click();
              });
          },
          () => {
            this.translation
              .translate('customUserPayments.errorExportInvoiceOverview')
              .pipe(take(1))
              .subscribe((message) => {
                this.messageService.add(
                  message,
                  GlobalMessageType.MSG_TYPE_ERROR
                );
              });
          }
        )
      )
      .subscribe((res) => {});
  }

  getPdf(pdfUrl: string){
    const params = {
      url: pdfUrl,
    };
    const url = this.endpoints.buildUrl('customUserPaymentsPdf', {queryParams: params});
    this.httpClient
      .get(url, { observe: 'body', responseType: 'arraybuffer' })
      .pipe(
        tap(
          (data) => {
              var file = new Blob([data], { type: 'application/pdf' })
              var fileURL = URL.createObjectURL(file);
              window.open(fileURL);
          },
          () => {
            this.translation
              .translate('customUserPayments.pdfError')
              .pipe(take(1))
              .subscribe((message) => {
                this.messageService.add(
                  message,
                  GlobalMessageType.MSG_TYPE_ERROR
                );
              });
          }
        )
      )
      .subscribe((res) => {});
  }

  exportInvoiceHistoryDetails(
    invoiceNumber: string, 
    companyCode: string, 
    bookingYear: string, 
    bookingTime: string){
      const params = {
        invoiceNumber: invoiceNumber,
        companyCode: companyCode,
        bookingYear: bookingYear,
        bookingTime: bookingTime,
      };
      this.translation
      .translate('customUserPayments.downloadInfo')
      .pipe(take(1))
      .subscribe((message) => {
        this.messageService.add(message, GlobalMessageType.MSG_TYPE_INFO);
      });
      const url = this.endpoints.buildUrl('customUserPaymentsDetailsDownload', {urlParams: params});
      var fileNameLoc = 'customUserPayments.files.details'
      this.httpClient
        .post(url, null, { observe: 'body', responseType: 'blob' })
        .pipe(
          tap(
            (data) => {
              this.translation
                .translate(fileNameLoc)
                .pipe(take(1))
                .subscribe((fileName) => {
                  var a = document.createElement('a');
                  a.setAttribute('download', fileName + '.csv');
                  a.href = URL.createObjectURL(data);
                  a.click();
                });
            },
            () => {
              this.translation
                .translate('customUserPayments.errorExportInvoiceDetails')
                .pipe(take(1))
                .subscribe((message) => {
                  this.messageService.add(
                    message,
                    GlobalMessageType.MSG_TYPE_ERROR
                  );
                });
            }
          )
        )
        .subscribe((res) => {});
  }
}
